import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../Login & Signup/login.css';

function LoginForm() {
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    navigate('/checkout');
  };

  return (
    <div className="auth-container" id='login-auth-container' >
      <div className="container">
        <h2>Login</h2>
        <form onSubmit={handleSubmit}>
          <input type="text" placeholder="E-mail" required />
          <input type="password" placeholder="Password" required />
          <div className="remember-me">
            <label>
              <input type="checkbox" /> Remember me
            </label>
          </div>
          <button type="submit">Log in</button>
        </form>

        <section className="footer">
          <p>Don't have an account..?</p>
          <Link to="/signup" style={{textDecoration:'none'}}>Sign Up</Link>
        </section>
      </div>
    </div>
  );
}

export default LoginForm;
